'use strict';

import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import scrollStore from './scroll.store';


let scrollObj = {y: 0};

let items = {};
let idName = 'scrollTo-id-';
let idNum  = 1;

let tween = false;
let played = false;



function _add(el) {
  let id = el.dataset.id;

  if (!id) {
    id = idName + idNum;
    idNum++;
  }

  let obj = {
    id: id,
    element: el,
    padding: el.dataset.padding
  };
  let dataElement = el.dataset.element;

  if (dataElement) {
    obj.dataElem = document.querySelector(dataElement);

    if (obj.dataElem) {
      el.addEventListener('click', _clickToElem.bind(obj), false);
      el.addEventListener('keydown', _clickToElem.bind(obj), false);
    }
  } else {
    let screenCount = +el.dataset.screen || 1;

    el.addEventListener('click', _clickScreen.bind(screenCount), false);
    el.addEventListener('keydown', _clickScreen.bind(screenCount), false);
  }


  items[id] = obj;
}



function _clickScreen(e) {
  e.preventDefault();
  if (e.type === 'keydown' && e.keyCode !== 13) return;

  _scrollTo(this * resizeStore.getData().height)
}
function _clickToElem(e) {
  e.preventDefault();
  if (e.type === 'keydown' && e.keyCode !== 13) return;

  _scrollToElem(this.dataElem, this.padding);
}


function _scrollToElem(elem, padding, time) {
  _scrollTo(elem.getBoundingClientRect().y + scrollStore.getData().top - (padding ? resizeStore.getData().width * padding : 0), time);
}


function _scrollTo(newY, time) {
  let y = scrollStore.getData().top;

  if (!time) {
    time = Math.abs((newY - y) / newY * 0.8);

    time = time < 0.4 ? 0.4 : time;
  }


  tween = TweenMax.fromTo(scrollObj, time, {
    y: y
  }, {
    ease: CustomEase.create("custom", "M0,0 C0,0 0.06109,0.00075 0.09824,0.0052 0.12625,0.00856 0.1446,0.01197 0.17082,0.02047 0.19486,0.02828 0.21142,0.03551 0.23263,0.04882 0.25581,0.06338 0.27052,0.07591 0.29044,0.09557 0.31305,0.11788 0.32683,0.13371 0.34515,0.15986 0.36721,0.19135 0.38133,0.2119 0.39683,0.24743 0.46864,0.41201 0.4993,0.51981 0.57385,0.68402 0.60631,0.75551 0.63318,0.79987 0.67584,0.86198 0.69581,0.89106 0.71543,0.90827 0.74313,0.93048 0.77077,0.95263 0.79279,0.96736 0.82446,0.98109 0.85315,0.99352 0.87707,0.9988 0.90861,1.00219 0.94184,1.00577 1,1 1,1 "),
    y: newY,
    onStart: function () {
      played = true;
    },
    onUpdate: function () {
      window.scrollTo(0, this.target.y);
    },
    onComplete: function () {
      played = false;
    }
  })
}



function _handleChange() {
  if (!played) return;

  tween.kill();

  played = false;
}






function _handleMutate() {
  let elements = document.querySelectorAll('.scrollTo');


  for (let i = 0; elements.length > i; i++) {
    check(elements[i])
  }
  for (let id in items) {
    if (items.hasOwnProperty(id)) backCheck(id);
  }

  function check(el) {
    for (let id in items) {
      if (items.hasOwnProperty(id) && items[id].element === el) return;
    }
    _add(el);
  }

  function backCheck(id) {
    for (let i = 0; elements.length > i; i++) {
      if (items[id].element === elements[i]) return;
    }
    delete items[id];
  }
}

function init() {
  _handleMutate();

  document.addEventListener('wheel', _handleChange);
  document.addEventListener('mousedown', _handleChange);
  document.addEventListener('touchstart', _handleChange);

  dispatcher.subscribe(function (e) {
    if (e.type === 'mutate') _handleMutate();
    if (e.type === 'scroll-to') {
      if (typeof e.elem === 'string') {
        _scrollToElem(document.querySelector(e.elem), e.padding, e.time);
      } else {
        _scrollToElem(e.elem, e.padding, e.time);
      }
    }
  });
}

export default {
  init: init
}
